export default __webpack_public_path__ + "static/media/Bg-3.ee641813.png";